import NiceModal from '@ebay/nice-modal-react';
export { useModal as baseModal } from '@ebay/nice-modal-react';
export type { NiceModalHocProps as DialogInnerProps } from '@ebay/nice-modal-react';

export const DialogProvider = ({ children }: React.PropsWithChildren) => {
    return <NiceModal.Provider>{children}</NiceModal.Provider>;
};

export type DialogStateManager = typeof NiceModal;
export const DialogStateManager = NiceModal;

export const useDialog = NiceModal.useModal;
